/**
 * @file payChannelList.ts
 * @description 支付渠道的枚举及其对应标签的定义。
 *              包含所有可能的支付渠道及其描述，便于在项目中统一管理和使用。
 *              提供方法以根据渠道获取对应的标签。
 */
export enum PayChannelEnum {
  GOOGLE = 'google',
  APPLE = 'apple',
  HUAWEI = 'huawei',
  HUAWEI_FOREIGN = 'huawei_foreign',
  HUAWEI_MG = 'huawei_mg',
  HUAWEI_RUNTIME_FASTGAME = 'huawei_runtime_fastgame',
  HARMONY = 'harmony',
  ALIPAY = 'alipay',
  ALIPAY_WEB = 'alipay_web',
  ALI_MINI_GAME = 'aliminigame',
  ALI_MINI_GAME_IOS = 'aliminigame_ios',
  DOUYIN_MINI_GAME = 'douyinOrdinaryMiniGame',
  DOUYIN_GAME = 'douyingame',
  WX_MINI_GAME = 'wxminigame',
  JS_API_PAY = 'jsapipay',
  XG_PAY = 'xgPay',
  XIAOMI = 'xiaomi',
  WXPAY = 'wxpay',
  WX_NATIVE_PAY = 'wxnativepay',
  MEIZU = 'meizu',
  AMAZON = 'amazon',
  KSMINIGAME = 'ksminigame',
  KSIOSMINIGAME = 'ksiosminigame',
  OPPO = 'oppo',
  OPPO_ONLINE = 'oppo_online',
  VIVO = 'vivo',
}

// 支付渠道分类列表
export const payChannelList = [
  { value: PayChannelEnum.GOOGLE, label: '谷歌' },
  { value: PayChannelEnum.APPLE, label: '苹果' },
  { value: PayChannelEnum.HUAWEI, label: '华为' },
  { value: PayChannelEnum.HUAWEI_FOREIGN, label: '华为海外' },
  { value: PayChannelEnum.HUAWEI_MG, label: '华为小游戏' },
  { value: PayChannelEnum.HUAWEI_RUNTIME_FASTGAME, label: '华为快游戏' },
  { value: PayChannelEnum.HARMONY, label: '鸿蒙' },
  { value: PayChannelEnum.ALIPAY, label: '支付宝' },
  { value: PayChannelEnum.ALIPAY_WEB, label: '支付宝电脑网站支付' },
  { value: PayChannelEnum.ALI_MINI_GAME, label: '支付宝小游戏' },
  { value: PayChannelEnum.ALI_MINI_GAME_IOS, label: '支付宝小游戏_iOS' },
  { value: PayChannelEnum.DOUYIN_MINI_GAME, label: '抖音普通小游戏' },
  { value: PayChannelEnum.DOUYIN_GAME, label: '抖音小游戏' },
  { value: PayChannelEnum.WX_MINI_GAME, label: '微信小游戏_安卓' },
  { value: PayChannelEnum.JS_API_PAY, label: '微信小游戏_IOS' },
  { value: PayChannelEnum.XG_PAY, label: '微信特殊渠道-XG' },
  { value: PayChannelEnum.XIAOMI, label: '小米支付' },
  { value: PayChannelEnum.WXPAY, label: '微信APP' },
  { value: PayChannelEnum.WX_NATIVE_PAY, label: '微信PC' },
  { value: PayChannelEnum.MEIZU, label: '魅族' },
  { value: PayChannelEnum.AMAZON, label: '亚马逊' },
  { value: PayChannelEnum.KSMINIGAME, label: '快手小游戏' },
  { value: PayChannelEnum.KSIOSMINIGAME, label: '快手IOS小游戏' },
  { value: PayChannelEnum.OPPO, label: 'oppo' },
  { value: PayChannelEnum.OPPO_ONLINE, label: 'oppo推广' },
  { value: PayChannelEnum.VIVO, label: 'vivo' },
]

// 新增方法，通过渠道value和key获取对应的属性值
export function getPayChannelProperty(value: PayChannelEnum, key: 'label'): string {
  const channelItem = payChannelList.find((item) => item.value === value)
  return channelItem ? channelItem[key] : '' // 如果渠道不存在，返回默认值
}
